import React from "react";
import { Tooltip } from "antd";

import { parseDateTime } from "../../../modules/consignmentFunctions";

export default function UserOperation({ operation }) {
  return operation ? (
    <Tooltip title={operation.email || "--"}>
      {parseDateTime(operation.dateTime)}
    </Tooltip>
  ) : (
    ""
  );
}
